import { pageMarketplace, pageProfiles, startsWithExtraPath } from "@/route";
import { Route, Switch, matchPath, useLocation } from "react-router-dom";
import MarketplacePage from "./marketplace";
import ProfilePage from "./profile";
import { ProfileAreaLayout } from "./profile-area-layout";

export function ProfileArea({ showCustomLogo }: { showCustomLogo?: boolean }) {
  const location = useLocation();
  const routePrefix = startsWithExtraPath(location.pathname);
  const profilesPath = `${routePrefix}${pageProfiles.pattern()}`;
  const marketplacePath = `${routePrefix}${pageMarketplace.pattern()}`;
  const activeTab = matchPath(location.pathname, { path: marketplacePath, exact: true }) ? "marketplace" : "profiles";

  return (
    <ProfileAreaLayout activeTab={activeTab} showCustomLogo={showCustomLogo}>
      <Switch>
        <Route exact path={profilesPath}>
          <ProfilePage />
        </Route>
        <Route exact path={marketplacePath}>
          <MarketplacePage />
        </Route>
      </Switch>
    </ProfileAreaLayout>
  );
}
